import React from 'react';
import useRoute from '../../routing/useRoute';
import styles from './styles.module.scss';

const Nav = () => {
  const currentLocation = useRoute().path;

  return <nav className={styles.nav}></nav>;
};

export default Nav;
